import React, { useCallback } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { EsgAddFile } from "assets";
import { DOCUMENT_UPLOAD_PAGE } from "pages/authenticated/documents";

export const UploadUtilityDataButton = ({ disabled }: { disabled: boolean }) => {
    const navigate = useNavigate();

    const onClick = useCallback(() => {
        navigate(DOCUMENT_UPLOAD_PAGE.ABSOLUTE_PATH);
    }, [navigate]);

    return (
        <Button startIcon={<EsgAddFile />} disabled={disabled} onClick={onClick} variant="contained" sx={{ width: '200px', px: '25px', height: '36px', borderRadius: 2, fontWeight: 500 }}>
            Upload Utility Data
        </Button >
    );
};